<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <CadastroSolicitacao />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>
<script>
import CadastroSolicitacao from "./../Components/Cadastros/CadastroSolicitacao.vue";

export default {
  name: "RegisterPromoter",
  components: {
    CadastroSolicitacao,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
